import React, { createContext, useState, useEffect } from "react";

export const RoomContext = createContext();

export const RoomProvider = ({ children }) => {
  const [rooms, setRooms] = useState([]);
  const BACK_API_BASE_URL = process.env.REACT_APP_BACK_API_BASE_URL;

  const fetchRooms = async (buildingId) => {
    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/building/load/${buildingId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        const { roomInfoList } = data;
        setRooms(roomInfoList);
        // console.log(response)
      } else {
        console.error("Failed to fetch rooms:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  const addRoom = async (newRoom) => {
    try {
      // console.log(newRoom)
      const response = await fetch(`${BACK_API_BASE_URL}/api/room/register`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        method: "POST",
        body: JSON.stringify(newRoom),
      });
      // console.log("토큰",sessionStorage.getItem('token'))
      // console.log(response)

      if (response.ok) {
        await fetchRooms(newRoom.buildingId);

        // const savedRoom = await response.json();
        // setRooms(prevRooms => [...prevRooms, savedRoom]);
      } else {
        const a = await response.json();
        console.error("Failed to add room:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding room:", error);
    }
  };

  const updateRoom = async (roomId, updatedRoom) => {
    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/room/modify/${roomId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "POST",
          body: JSON.stringify(updatedRoom),
        }
      );

      if (response.ok) {
        await fetchRooms(updatedRoom.buildingId);
        // const savedRoom = await response.json();
        // setRooms(prevRooms =>
        //   prevRooms.map(room => room.id === roomId ? savedRoom : room)
        // );
      } else {
        console.error("Failed to update room:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating room:", error);
    }
  };

  const deleteRoom = async (roomId, buildingId) => {
    // console.log("삭제할 호실 아이디:",roomId)
    // console.log("삭제할 호실 건물 아이디: ", buildingId)

    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/room/delete/${roomId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );
      // console.log(response)

      if (response.ok) {
        await fetchRooms(buildingId);
      } else {
        console.error("Failed to delete room:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting room:", error);
    }
  };

  return (
    <RoomContext.Provider
      value={{ rooms, fetchRooms, addRoom, updateRoom, deleteRoom }}
    >
      {children}
    </RoomContext.Provider>
  );
};
